'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import SvgResume from '../icons/SvgResume';
import SvgResumeHover from '../icons/SvgResumeHover';
import SvgConsult from '../icons/SvgConsult';
import SvgConsultHover from '../icons/SvgConsultHover';
import SvgSalary from '../icons/SvgSalary';
import SvgSalaryHover from '../icons/SvgSalaryHover';
import SvgCulture from '../icons/SvgCulture';
import SvgCultureHover from '../icons/SvgCultureHover';
// import SvgJob from './SvgJob';
import {
  CANDIDATES_ME_ROUTER_PATH,
  CULTURAL_RESULT_ROUTER_PATH,
  JOB_SALARY_INSIGHT_ROUTER_PATH,
  RESUME_CONSULTATION_ORDER_ROUTER_PATH,
} from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';

const NAV_LINK = [
  {
    name: '我的简历',
    link: CANDIDATES_ME_ROUTER_PATH,
    icon: (
      <SvgResume className="block group-data-[selected=true]:hidden group-hover:hidden" />
    ),
    hoverIcon: (
      <SvgResumeHover className="hidden group-data-[selected=true]:block group-hover:block" />
    ),
    dataEleId: 'btn_我的简历',
  },
  {
    name: '简历咨询',
    link: RESUME_CONSULTATION_ORDER_ROUTER_PATH,
    icon: (
      <SvgConsult className="block group-data-[selected=true]:hidden group-hover:hidden" />
    ),
    hoverIcon: (
      <SvgConsultHover className="hidden group-data-[selected=true]:block group-hover:block" />
    ),
    dataEleId: 'btn_简历咨询',
  },
  {
    name: '薪资洞察',
    link: JOB_SALARY_INSIGHT_ROUTER_PATH,
    isMulti: true,
    icon: (
      <SvgSalary className="block group-data-[selected=true]:hidden group-hover:hidden" />
    ),
    hoverIcon: (
      <SvgSalaryHover className="hidden group-data-[selected=true]:block group-hover:block" />
    ),
    dataEleId: 'btn_薪酬数据',
  },
  {
    name: '职场偏好',
    link: CULTURAL_RESULT_ROUTER_PATH,
    icon: (
      <SvgCulture className="block group-data-[selected=true]:hidden group-hover:hidden" />
    ),
    hoverIcon: (
      <SvgCultureHover className="hidden group-data-[selected=true]:block group-hover:block" />
    ),
    dataEleId: 'btn_职场文化偏好',
  },
  // {
  //   name: '寻找工作',
  //   link: '',
  //   icon: <SvgJob />,
  // },
];

const NavLink = (props: {
  className?: string;
  isSalaryLink?: boolean;
  iconClassName?: string;
}) => {
  const {
    className = 'flex flex-col mt-12 gap-y-5',
    isSalaryLink = false,
    iconClassName = 'mb-0.5 tablet:mb-1',
  } = props;
  const pathname = usePathname();

  return (
    <div className={className}>
      {NAV_LINK.map(({ name, link, icon, hoverIcon, isMulti, dataEleId }) => (
        <Link
          key={name}
          href={link}
          data-selected={pathname === link || !!(isMulti && isSalaryLink)}
          className="flex flex-col items-center text-sm text-center whitespace-nowrap rounded-lg group hover:bg-primary/[0.08] tablet:px-2.5 tablet:py-3.5"
          data-ele-group="navigation"
          data-ele-id={dataEleId}
          onClick={(e) => trackClickEvent(e, true)}
        >
          <span className={iconClassName}>
            {icon}
            {hoverIcon}
          </span>
          <span className="text-web-grey-500 group-data-[selected=true]:text-web-black-100 group-hover:text-web-black-100">
            {name}
          </span>
        </Link>
      ))}
    </div>
  );
};

export default NavLink;
